export default "__VITE_ASSET__BA9tqgh$__"